import React from "react";
import { Link } from "react-router-dom";
import { formatDate } from "../../helper/Helper";

function NotificationRow({ order }) {
  return (
    <li key={order.orderId} className="notification-message">
      <Link
        to={`/orders/details/${order.orderId}`}
        className="text-decoration-none"
      >
        <div className="d-flex hover-bg">
          <div
            className="me-2 d-flex align-items-center justify-content-center"
            style={{
              width: 40,
              height: 40,
              borderRadius: "50%",
              background: "#e8f0fe",
              color: "#0d6efd",
              fontSize: 18,
            }}
          >
            📦
          </div>

          <div className="flex-grow-1">
            <div className="fs-12">
              <strong>New Order Received</strong> 🎉
              <br />
              Order <strong>#{order.orderId}</strong> has been successfully
              placed.
            </div>

            <div className="fs-12 text-muted"
            >
              Amount: <strong>₹{order.total}</strong>
            </div>

            <div className="d-flex justify-content-between align-items-center mt-1">
              <small className="text-muted">
                {formatDate(order.createdAt)}
              </small>

              <span
                style={{
                  fontSize: "12px",
                  color: "#0d6efd",
                  fontWeight: 500,
                }}
              >
                View Details →
              </span>
            </div>
          </div>
        </div>
      </Link>
    </li>
  );
}

export default NotificationRow;
